export class CategoryModel {
    id: string;
    integrationId: string;
    name: string;
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/category.model.ts